const defaultConfig = {
  appVersion: '6.2.19',
  appPlatformVersion: '4.7.6'
}
export default defaultConfig
